export const navigation = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer'
  }, {
    name: 'Admin Dashboard',
    url: '/admin/dashboard',
    icon: 'icon-speedometer'
  },
  {
    name: 'Manage Users',
    url: '/user',
    icon: 'icon-user'
  },
  {
    name: 'Lead',
    url: '/lead',
    icon: 'icon-user-following'
  },
  {
    name: 'Payment',
    url: '/payment',
    icon: 'fa fa-dollar',
    children: [
      {
        name: 'Product Sell History',
        url: '/product-sales-history',
        icon: 'icon-people'
      },
      {
        name: 'Payment Collection',
        url: '/payment-collection',
        icon: 'icon-people'
      },
      {
        name: 'Payment Deposition',
        url: '/payment-deposition',
        icon: 'icon-basket'
      }
    ]
  },
  {
    name: 'Account Management',
    url: '/assignment',
    icon: 'icon-note'
  },
  {
    name: 'Report',
    url: '',
    icon: 'icon-home',
    children: [
      {
        name: 'Lead Activity',
        url: '/leadActivity',
        icon: 'icon-home'
      },
      {
        name: 'A/C Mgmt Activity',
        url: '/assignmentActivity',
        icon: 'icon-people'
      }
    ]
  },
  {
    name: 'Product',
    url: '/product',
    icon: 'icon-basket'
  },
  {
    name: 'Complain Mgmt',
    url: '/complainmanagement',
    icon: 'icon-bubbles'
  },
  {
    name: 'Settings',
    url: '',
    icon: 'icon-settings',
    children: [
      {
        name: 'City',
        url: '/city',
        icon: 'icon-home'
      },
      {
        name: 'Role',
        url: '/role',
        icon: 'icon-people'
      },
      {
        name: 'Area management',
        url: '/areaManagement',
        icon: 'icon-home'
      },
      {
        name: 'Holiday',
        url: '/holiday',
        icon: 'icon-people'
      },
      {
        name: 'Goal',
        url: '/goal',
        icon: 'icon-people'
      },
      {
        name: 'Change Owner',
        url: '/changeOwner',
        icon: 'icon-people'
      }
    ]
  },

  // ,{
  //   name: 'Report',
  //   url : '',
  //   icon: 'icon-home',
  //   children: [
  //     {
  //       name: 'Lead Activity',
  //       url: '/leadActivity',
  //       icon: 'icon-home'
  //     },
  //     {
  //       name: 'Assignment Activity',
  //       url: '/assignmentActivity',
  //       icon: 'icon-people'
  //     }
  //   ]
  // },
  {
    name: 'Admin Report',
    url: '/adminReport',
    icon: 'icon-home',
  },
];



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/_nav.ts